import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { Grid, Box, Button } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useNavigate } from 'react-router-dom';
const SignInSchema = Yup.object().shape({
	username: Yup.string().required('Username Required'),
	password: Yup.string().required('Password Required'),
});
const LoginForm = () => {
	const navigate = useNavigate();
	const [step, setStep] = useState('one');
	return (
		<Formik
			initialValues={{
				phone: '',
			}}
			validationSchema={SignInSchema}
			onSubmit={(values) => {
				console.log('signIn', values);
			}}>
			{(formik) => {
				const { errors } = formik;
				return (
					<Form
						style={{
							background: 'white',
							marginTop: 40,
							padding: 20,
							marginBottom: 40,
						}}>
						<h3 style={{ textAlign: 'center', fontSize: 16 }}>
							Login with Loofer
						</h3>
						<Box
							style={{
								display: 'flex',
								marginLeft: 30,
								marginRight: 30,
								border: '1px solid grey',
							}}>
							<Box
								onClick={() => setStep('one')}
								style={{
									background: step === 'one' ? 'rgb(51 65 127)' : '',
									textAlign: 'center',
									color: step === 'one' ? 'white' : 'black',
									width: '100%',
									padding: 12,
									cursor: 'pointer',
								}}>
								Login
							</Box>
							<Box
								onClick={() => setStep('two')}
								style={{
									width: '100%',
									padding: 12,
									textAlign: 'center',
									background: step === 'two' ? 'rgb(51 65 127)' : '',
									color: step === 'two' ? 'white' : 'black',
									cursor: 'pointer',
								}}>
								Register
							</Box>
						</Box>
						<Box
							style={{
								background: '#e6e7e8',
								padding: 20,
								marginTop: 20,
								border: '1px solid lightgrey',
								marginLeft: 30,
								marginRight: 30,
							}}>
							<Box
								style={{
									display: 'flex',
									marginLeft: 30,
									marginBottom: 20,
									marginRight: 30,
								}}>
								<Box
									style={{
										background: 'white',
										textAlign: 'center',
										color: 'black',
										width: '90%',
										padding: 8,
										border: '1px solid grey',
										borderRadius: 12,
										display: 'flex',
										alignItems: 'center',
									}}>
									<img
										src='data:image/png;base64,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'
										style={{ height: 25, marginLeft: 10 }}
									/>
									<span style={{ marginLeft: 10 }}>Facebook</span>
								</Box>
								<Box
									style={{
										background: 'white',
										textAlign: 'center',
										color: 'black',
										width: '90%',
										padding: 8,
										marginLeft: 10,
										border: '1px solid grey',
										borderRadius: 12,
										display: 'flex',
										alignItems: 'center',
									}}>
									<img
										src='data:image/png;base64,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'
										style={{ height: 25, marginLeft: 10 }}
									/>
									<span style={{ marginLeft: 10 }}>Google</span>
								</Box>
							</Box>
							<Box
								style={{
									display: 'flex',
									marginLeft: 30,
									marginBottom: 20,
									marginRight: 30,
									justifyContent: 'center',
								}}>
								<span>-OR-</span>
							</Box>
							{step === 'one' ? (
								<Grid
									container
									style={{ marginLeft: 30, marginBottom: 20, marginRight: 30 }}>
									<Grid item xs={12}>
										<Field
											style={{
												border: errors.phone
													? '1px solid red'
													: '1px solid blue',
												padding: '10px',
												width: '75%',
												borderRadius: 8,
											}}
											type='number'
											placeHolder='Enter Phone Number'
											name='phone'></Field>
										{errors.phone ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.phone}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12}>
										<Button
											style={{
												background: 'rgb(51 65 127)',
												width: '85%',
												color: 'white',
												padding: 8,
												borderRadius: 15,
												marginTop: 20,
											}}>
											PROCCED
										</Button>
									</Grid>
								</Grid>
							) : (
								<Grid
									container
									style={{ marginLeft: 30, marginBottom: 20, marginRight: 30 }}>
									<Grid item xs={6}>
										<Field
											style={{
												border: errors.phone
													? '1px solid red'
													: '1px solid blue',
												padding: '10px',
												width: '70%',
												borderRadius: 8,
											}}
											type='number'
											placeHolder='First Name'
											name='phone'></Field>
										{errors.phone ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.phone}
											</span>
										) : null}
									</Grid>
									<Grid item xs={6}>
										<Field
											style={{
												border: errors.phone
													? '1px solid red'
													: '1px solid blue',
												padding: '10px',
												width: '60%',
												borderRadius: 8,
											}}
											type='number'
											placeHolder='Last Name'
											name='phone'></Field>
										{errors.phone ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.phone}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12}>
										<Field
											style={{
												border: errors.phone
													? '1px solid red'
													: '1px solid blue',
												padding: '10px',
												width: '80%',
												borderRadius: 8,
												marginTop: 20,
											}}
											type='email'
											placeHolder='Email'
											name='phone'></Field>
										{errors.phone ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.phone}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12}>
										<Field
											style={{
												border: errors.phone
													? '1px solid red'
													: '1px solid blue',
												padding: '10px',
												width: '80%',
												borderRadius: 8,
												marginTop: 20,
											}}
											type='email'
											placeHolder='Email'
											name='phone'></Field>
										{errors.phone ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.phone}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12}>
										<Field
											style={{
												border: errors.phone
													? '1px solid red'
													: '1px solid blue',
												padding: '10px',
												width: '80%',
												borderRadius: 8,
												marginTop: 20,
											}}
											type='email'
											placeHolder='Email'
											name='phone'></Field>
										{errors.phone ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.phone}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12}>
										<Field
											style={{
												border: errors.phone
													? '1px solid red'
													: '1px solid blue',
												padding: '10px',
												width: '80%',
												borderRadius: 8,
												marginTop: 20,
											}}
											type='email'
											placeHolder='Email'
											name='phone'></Field>
										{errors.phone ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.phone}
											</span>
										) : null}
									</Grid>
									<FormControl style={{ marginTop: 10 }}>
										<FormLabel
											id='demo-row-radio-buttons-group-label'
											style={{ color: 'black' }}>
											Gender
										</FormLabel>
										<RadioGroup
											row
											aria-labelledby='demo-row-radio-buttons-group-label'
											name='row-radio-buttons-group'>
											<FormControlLabel
												value='female'
												control={<Radio />}
												label='Female'
											/>
											<FormControlLabel
												value='male'
												control={<Radio />}
												label='Male'
											/>
											<FormControlLabel
												value='other'
												control={<Radio />}
												label='Other'
											/>
										</RadioGroup>
									</FormControl>
									<Grid item xs={12}>
										<Button
											style={{
												background: 'rgb(51 65 127)',
												width: '85%',
												color: 'white',
												padding: 8,
												borderRadius: 15,
												marginTop: 20,
											}}>
											PROCCED
										</Button>
									</Grid>
								</Grid>
							)}
							<Box
								style={{
									display: 'flex',
									marginLeft: 30,
									marginBottom: 20,
									marginRight: 30,
									justifyContent: 'center',
								}}>
								<span>
									New User? <span style={{ color: 'red' }}>Create Account</span>
								</span>
							</Box>
						</Box>
					</Form>
				);
			}}
		</Formik>
	);
};

export default LoginForm;
